var InGo = require('./ingo-global');
var debug = require('ingo-debug');

var util = require('widgets-util');
var loadJS = require('./load-script');
var loadCSS = require('./load-css');
var async = require('widgets-util/async');
var Api = require('./api');
var getJQuery = require('./jquery');

var defaultOptions = {
  baseUrl: 'https://ingo.me',
  version: '0.9.1'
};


function runWidget(container, config, options) {
  var opts = util.deepExtend({}, config.params, options);

  debug('runWidget:', config.type, config.version, opts);

  var methodName = config.type + 'Widget';
  if (config.useJQuery && InGo.$ && InGo.$.fn[methodName]) {
    InGo.$(container)[methodName](opts);
  } else if (InGo[methodName]) {
    InGo[methodName](opts);
  } else {
    throw new Error('InGo: Unable to find ' + methodName);
  }

  if (typeof options.onLoad === 'function') {
    options.onLoad(config);
  }
}

/**
 * Replace url from .min.js to be .js if InGo._debug enabled. See ingo-debug.
 * Then delegate options to usual script
 * @param  {string}   url
 * @param  {Function} callback
 */
function loadDebugJs(url, callback) {
  if(InGo._debug && url.match(/\.min\.js$/)) {
    url = url.substr(0, url.length - 7) + '.js';
  }
  debug('load', url);
  loadJS(url, callback);
}

/**
 * Load config resources from loaded config.
 * First css then js.
 *
 * @param  {InGo|Node|NodeList} el
 * @param  {Object} config  config loaded from server
 * @param  {[type]} options options from script invocation
 */
function loadWidgetConfig(el, config, options) {
  var configs = InGo._widgets = InGo._widgets || {};

  debug('loadWidgetConfig:', config.type, config.version, config.js, config.css);

  if (!configs[config.type + '-' + config.version]) {
    async.forEach(config.css, loadCSS);
    async.forEachOrdered(config.js, loadDebugJs, function() {
      configs[config.type + '-' + config.version] = config.params;
      runWidget(el, config, options);
    });
  } else {
    runWidget(el, config, options);
  }
}


function ingoWidget(options) {
  var that = this;
  options = util.deepExtend({}, defaultOptions, options);
  var api = new Api(options);

  api.config({}, function(config) {
    if (config.useJQuery) {
      getJQuery(options, ingoWidget, function() {
        loadWidgetConfig(that, config, options);
      });
    } else {
      loadWidgetConfig(that, config, options);
    }
  });
  return this;
}


// Global widget reference
InGo.ingoWidget = InGo.loaderWidget = ingoWidget;
// To be able to launch widgets from the global jQuery selector
if(window.jQuery) {
  window.jQuery.fn.ingoWidget = window.jQuery.fn.loaderWidget = ingoWidget;
}

// Extract tag attributes so we can use base url for loading other scripts
require('./script-tag').runTag(ingoWidget);

module.exports = ingoWidget;//for testing convinience
